import { Option as SelectOption } from 'rc-select';
import React from 'react';

import { useGlobalState } from '../../global-state';
import { SelectInput, SelectInputProps } from '../../ui/select-input';
import { getRegions } from './regions';

export const RegionInput: React.FC<SelectInputProps> = props => {
  const globalState = useGlobalState();

  return (
    <SelectInput {...props}>
      {getRegions(globalState.purchase_country).map(([id, name]) => (
        <SelectOption key={id} value={id}>
          {name}
        </SelectOption>
      ))}
    </SelectInput>
  );
};
